// extracted by mini-css-extract-plugin
export default {"button":"button__2Fk_Y","ripple":"ripple__1NAjZ","disabled":"disabled__3FI8q"};